module.exports = __webpack_public_path__ + "static/media/defect-table-blurred.8da080d1.jpg";